import { ChangeDetectorRef, Directive, ElementRef, inject, input, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isNotEmpty } from '../../functions';
import { IBaseInputMask } from '../functions';

/**
 * @description
 * the current input-masking library, doesn't toggle the mask pattern visibility.
 * the template is always shown, even when the input is not focused. this directive
 * override that default behavior. placing it on an input element, will toggle the
 * mask visibility on focus and blur events.
 */

@Directive({
  selector: '[maskOnFocus]',
  standalone: true,
  host: {
    '(focus)': 'apply(true, $event)',
    '(blur)': 'apply(false, $event)'
  },
  exportAs: 'maskState'
})
export class MaskToggleDirective {
  #changeDetector = inject(ChangeDetectorRef);
  #sourceElement = inject(ElementRef).nativeElement;

  maskOnFocus = input.required<[FormControl, IBaseInputMask]>();

  readonly isApplied = signal(false);

  constructor() {}

  apply(shouldApply: boolean, event?: FocusEvent) {
    // event?.stopImmediatePropagation();
    const [formControl, maskOptions] = this.maskOnFocus();

    if (!shouldApply) {
      shouldApply = isNotEmpty(formControl.value); // this.#sourceElement.value === maskOptions.maskPattern;
    }

    this.isApplied.set(shouldApply);
    formControl.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    this.#changeDetector.detectChanges();
  }
}
